import { gql } from "@apollo/client"

const UPDATE_SLOTS_STATUS = gql`
  mutation updateSlotsStatus($input: UpdateSlotsStatusInput!) {
	  updateSlotsStatus(input: $input) {
      updated {
        id
        capacity
        remaining
        status
      }

      skipped {
        id
        capacity
        remaining
        status
        bookingSlots {
          id
          booking_id
          student {
            id
            forename
            surname
          }
        }
      }
	  }
  }
`

export { UPDATE_SLOTS_STATUS }
